import React, { useState } from 'react'
import { Button, Col, Row, Spinner } from 'react-bootstrap'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import { db, makeid } from '../helper/helper'
import { toast } from 'react-toastify'
export default function Inquiry() {


    const [showLoader, setShowLoader] = useState(false)

    const phoneRegExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/
    const formik = useFormik({
        initialValues: {

            full_name: "",
            contact_number: "",
            product: "blackout",
            quantity: "",
            unit: "Meter",
        },


        validationSchema: Yup.object({

            contact_number: Yup.string().matches(phoneRegExp, 'Phone number is not valid')
                .required("Required!"),
            full_name: Yup.string()
                .required("Required!"),
            product: Yup.string()
                .required("Required!"),
            quantity: Yup.number()
                .required("Required!"),


        }),
        onSubmit: values => {
            setShowLoader(true)
            values.id = makeid(8)
            values.createdAt = Date.now()
            addInquiryInDatabase(values)


        }
    });


    const addInquiryInDatabase = (values) => {
        let itemaddquery = new Promise((resolve, reject) => {

            db.collection("kvhInquiry").add(values)

                .then((docRef) => {
                    resolve(docRef.id);
                    formik.resetForm()
                    toast.success('Thanks for Inquiry our Salesman Contact you soon.');


                })
                .catch((error) => {
                    console.error("Please check form again ", error);
                    reject(error);
                });
        });
        itemaddquery.then(result => {
            console.warn('Entry Added')
            setShowLoader(false)
        }).catch(err => {
            console.error(err)
            setShowLoader(false)
            if (err.message == 'Quota exceeded.') {
                toast.error('Your Daily limit is exceeded')
            }
        });
    }


    return (

        <div className="row justify-content-center bg-image mx-0 mb-5" id='inquiry'>
            <div className="col-lg-6 py-5">
                <div className="bg-white p-5 my-5">
                    <h1 className="text-center mb-4"> For Inquiry</h1>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-sm-6 mt-3">
                                <div className="form-group">
                                    <input id="s-name" name='full_name' value={formik.values.full_name}
                                        onChange={formik.handleChange} type="text" className="form-control bg-light border-0 "
                                        placeholder="Your Name" />
                                    {formik.errors.full_name && formik.touched.full_name && (
                                        <p className='text-danger'>{formik.errors.full_name}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-6 mt-3">
                                <div className="form-group">
                                    <input id="s-number" name='contact_number' value={formik.values.contact_number}
                                        onChange={formik.handleChange} type="tel" className="form-control bg-light border-0 "
                                        placeholder="Your Contact No" />
                                    {formik.errors.contact_number && formik.touched.contact_number && (
                                        <p className='text-danger'>{formik.errors.contact_number}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-sm-6 mt-3">
                                <div className="form-group">
                                    <select name='product' id="s-subject" value={formik.values.product}
                                        onChange={formik.handleChange} className="form-select form-control bg-light border-0 px-3"
                                    >
                                        <option value="">Select a Product</option>
                                        <option value="blackout">Blackout Fabric</option>
                                        <option value="velvet">Velvet Fabric</option>
                                        <option value="sheer">Sheer Fabric</option>

                                    </select>
                                    {formik.errors.product && formik.touched.product && (
                                        <p className='text-danger'>{formik.errors.product}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-6 mt-3">
                                <Row>
                                    <Col xs={8} className='pe-0'>
                                        <input name='quantity' value={formik.values.quantity}
                                            onChange={formik.handleChange} className='form-control bg-light border-0' placeholder='Quantity' />

                                    </Col>
                                    <Col xs={4} className='ps-0'>
                                        <input name='unit' value={formik.values.unit}
                                            onChange={formik.handleChange} className='form-control bg-light border-0' placeholder='Meter' /></Col>
                                </Row>
                                {formik.errors.quantity && formik.touched.quantity && (
                                    <p className='text-danger'>{formik.errors.quantity}</p>
                                )}
                            </div>
                        </div>
                        <div className='mt-3 text-center'>
                            <Button type='submit' disabled={showLoader} > {showLoader ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> : 'Submit'}  </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}
